
import { Vue, Component, Prop } from "vue-property-decorator";
import { printPluginDownloadUrl, pdfReaderDownloadUrl } from "../config";
@Component
export default class wmsPrintPdfTips extends Vue {
  pluginDownloadUrl = printPluginDownloadUrl;
  pdfReaderDownloadUrl = pdfReaderDownloadUrl;
  openGuidesPage() {
    // window.open(`${location.origin}/#/component/wmsPrintPdfGuides`);
    window.open(
      `https://help.lg2w.cn/web/#/p/605230aef789e5fa9d0e1f9874f247c6`
    );
  }
}
